import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import Cropper from 'cropperjs/dist/cropper.esm';
import { environment } from '../../../../../../../../environments/environment';

@Component({
	selector: 'fu-edit-modal',
	templateUrl: './fu-edit-modal.component.html',
	styleUrls: ['./fu-edit-modal.component.scss']
})
export class FileUploadEditModalComponent implements OnInit, AfterViewInit {
	@Input() file;
	@Input() allowedDimensions;
	@Input() isPopup;
	@Output() output = new EventEmitter<any>();
	@ViewChild('photo', { static: true }) photo: ElementRef;
	@ViewChild('thumbnail', { static: true }) thumbnail: ElementRef;
	cropper;
	listHeight = window.innerHeight * 0.63;
	allowedDimensionsArr;
	webComponentDomain = environment.webComponentUrl;

	constructor() {}

	ngOnInit() {
		if (this.allowedDimensions) {
			this.allowedDimensionsArr = this.allowedDimensions.split('x');
		} else {
			this.allowedDimensionsArr = [this.file.dimensions[0], this.file.dimensions[1]];
		}
	}

	ngAfterViewInit() {
		const self = this;

		this.cropper = new Cropper(this.photo.nativeElement, {
			viewMode: 1,
			aspectRatio: !!this.allowedDimensions ? +this.allowedDimensionsArr[0] / +this.allowedDimensionsArr[1] : NaN,
			preview: '.previewImage',
			zoomOnWheel: false,
			autoCrop: !this.allowedDimensions,
			cropBoxResizable: !this.allowedDimensions,
			dragMode: 'move',
			toggleDragModeOnDblclick: false,
			ready: function (e) {
				const containerData = self.cropper.getContainerData();
				const imageData = self.cropper.getImageData();
				const left = (containerData.width - imageData.naturalWidth) / 2;
				if (!!this.allowedDimensions) {
					self.cropper.setCanvasData({
						left: left,
						top: 0,
						width: imageData.naturalWidth,
						height: imageData.naturalHeight
					});
				}
				self.cropper.crop();
			}
		});
	}

	flip(type) {
		const data = this.cropper.getData();
		if (type === 'h') {
			this.cropper.scale(data.scaleX * -1, data.scaleY);
		} else {
			this.cropper.scale(data.scaleX, data.scaleY * -1);
		}
	}

	updateCanvas() {
		this.cropper.setCropBoxData({ width: +this.allowedDimensionsArr[0], height: +this.allowedDimensionsArr[1] });
	}

	saveClose() {
		const canvas = this.cropper.getCroppedCanvas({
			width: +this.allowedDimensionsArr[0],
			height: +this.allowedDimensionsArr[1],
			fillColor: '#fff'
		});

		canvas.toBlob((blob) => {
			const time = new Date().getTime();
			this.output.emit({
				method: 'saveClose',
				blob: blob,
				fileName: this.allowedDimensionsArr[0] + 'x' + this.allowedDimensionsArr[1] + '_' + time + '_' + this.file.name
			});
		});
	}

	saveSelect() {
		const canvas = this.cropper.getCroppedCanvas({
			width: +this.allowedDimensionsArr[0],
			height: +this.allowedDimensionsArr[1],
			fillColor: '#fff'
		});

		canvas.toBlob(
			(blob) => {
				const time = new Date().getTime();
				this.output.emit({
					method: 'saveSelect',
					blob: blob,
					fileName: this.allowedDimensionsArr[0] + 'x' + this.allowedDimensionsArr[1] + '_' + time + '_' + this.file.name
				});
			},
			'image/jpeg',
			0.95
		);
	}

	cancel() {
		this.output.emit({ method: 'cancel' });
	}
}
